<div #categories class="main">
  <div class="wrapper">
    <img src="/assets/images/logo-full-white.svg" alt="Bulgari">
    <!-- <h1>{{ "Bulgari Catalogo" | translate }}</h1> -->
    <button class="btn btn-primary" (click)="scrollService.scrollToElement(categories)">
      {{ "Discover All Creations" | translate }}
    </button>
  </div>
</div>

<app-categories-page #categoriesRef></app-categories-page>
<app-terms-and-conditions-modal #termsAndConditionsModal></app-terms-and-conditions-modal>
